export function secondsToString(time) {
  const minutes = Math.floor(time / 60);
  const seconds   = time % 60;

  const minuteLabel = minutes === 1 ? t('time.minute') : t('time.minutes', { minutes: minutes });
  const secondsLabel = seconds === 1 ? t('time.second') : t('time.seconds', { seconds: seconds < 10 ? `0${seconds}` : seconds });

  return t('time.time_left', { minutes: minuteLabel, seconds: secondsLabel });
}

export default { secondsToString };
